// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1nCBu","notes":"Notes_notes__1HlMI"};